<template>
  <div>
    <card>
      <div class="row details-container mb-0">
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.action')"
            :field="error.action"
            :edit="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.status')"
            :field="error.status"
            :edit="false"
          />
        </div>
      </div>
      <div class="row details-container">
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.partyId')"
            :field="error.party_id"
            :edit="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.uid')"
            :field="error.uid"
            :edit="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.countryCode')"
            :field="error.country_code"
            :edit="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.visualNumber')"
            :field="error.visual_number"
            :edit="false"
          />
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
          <VerticalDetail
            :label="$t('sections.tokenErrors.fields.type')"
            :field="error.type"
            :edit="false"
          />
        </div>
      </div>
    </card>
    <span class="section-title">
      {{ $t("sections.tokenErrors.fields.statusMessage") }}
    </span>
    <card class="status-message mt-2">
      <span> {{ error.message }} </span>
    </card>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import VerticalDetail from '@/components/ui/VerticalDetail.vue';

export default {
  name: 'TokenError',
  components: {
    VerticalDetail,
  },
  data() {
    return {
      error: {
        action: undefined,
        status: undefined,
        party_id: undefined,
        uid: undefined,
        country_code: undefined,
        visual_number: undefined,
        type: undefined,
        message: undefined,
      },
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.error = cloneDeep(
        await this.$store.dispatch('getError', this.$route.params.id),
      );
    }
  },
};
</script>
<style lang="scss" scoped>
.status-message {
  white-space: pre-line;
}
</style>
